@file:kotlin.js.JsExport
package com.narbase.letsgo.dto.lists

import com.narbase.letsgo.dto.core.DateTimeDto

/*
 * NARBASE TECHNOLOGIES CONFIDENTIAL
 * ______________________________
 * [2017] - [2021] Narbase Technologies
 * All Rights Reserved.
 * Created by nezuma
 * On: 11/22/22.
 */
data class ListItemDto(
        val id: String?,
        val clinicId: String?,
        val createdOn: DateTimeDto?,
        val name: String,
        val order: Int?,
        val isHidden: Boolean,
        val customData: TableCustomDataDto?
)

class TableCustomDataDto(val map: Array<SimpleKeyValueDto>)
class SimpleKeyValueDto(val key: String, val value: String)
